import { IArticle } from '../types/IArticle'
import { IArticleTransformed } from '../types/IArticleTransformed'
import { IAudioDuration } from '../types/IAudioDuration'

const transformSecsToMins = (seconds: number) => {
    const mins = seconds / 60

    if (mins < 1) {
        return '<1 min'
    }

    return `${Math.round(mins)} mins`
}

const transformDateToText = (date: Date | string) => {
    const dateFixed = date instanceof Date ? date : new Date(date)

    const dayOfMonth = dateFixed.getDate()
    const month = dateFixed.getMonth()

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    return `${months[month]} ${dayOfMonth}`
}

export const transformArticleFromResponse = (article: IArticle): IArticleTransformed => {
    return {
        id: article.id,
        name: article.name,
        shareUrl: article.shareUrl,
        articleOriginUrl: article.articleOriginUrl,
        audioLength: {
            seconds: article.audioLength,
            text: transformSecsToMins(article.audioLength),
        },
        date: transformDateToText(article.publisherPublicationDate),
        image: article.image,
        audio: article.audio,
        publisher: article.publisher,
        offPlatformToNoaLink: article.offPlatformToNoaLink,
    }
}

export const transformAudioDuration = (params: { audioDurationSeconds: number }): IAudioDuration => {
    const secsRounded = Math.round(params.audioDurationSeconds)

    const mins = Math.floor(secsRounded / 60)
    const minsFormatted = formatNumberToTime({ num: mins })

    const secs = secsRounded % 60
    const secsFormatted = formatNumberToTime({ num: secs })

    return {
        seconds: params.audioDurationSeconds,
        minutesAndSecs: `${minsFormatted}:${secsFormatted}`,
    }
}

const formatNumberToTime = (params: { num: number }): string => {
    if (params.num < 10) {
        return `0${params.num}`
    }

    return `${params.num}`
}
